import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { ChancenEventlog } from './ChancenEventlog.js';

@Entity()
export class ChancenKurveEventlog extends ChancenEventlog {
  static override _class = 'ChancenKurveEventlog';

  constructor(doc: PartialEntityData<ChancenKurveEventlog>) {
    super(doc);
  }

  @validate(nonOptional())
  @Field(() => ID)
  lessonID!: string;
}
